<template>
  <div>
    <div class="table-container">
      <div class="container-head">
        <label>用户ID</label>
        <el-input
          class="input"
          v-model="userId"
          placeholder="请输入用户ID"
        ></el-input>
        <!-- <label>查询日期</label>
        <el-date-picker
          v-model="time"
          type="daterange"
          align="center"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker> -->
        <el-button
          class="btn"
          :loading="loading"
          type="primary"
          @click="getListData"
          >查询</el-button
        >
      </div>
      <el-table
        :data="tableData"
        stripe
        border=""
        height="500"
        style="width: 100%"
      >
        <el-table-column prop="time" label="日期"></el-table-column>
        <el-table-column prop="id" label="流水ID"></el-table-column>
        <el-table-column prop="user_id" label="用户ID"></el-table-column>
        <el-table-column
          prop="user_info.nickname"
          label="昵称"
        ></el-table-column>
        <el-table-column prop="source_type" label="交易来源"></el-table-column>
        <el-table-column prop="type" label="交易类型"></el-table-column>
        <el-table-column prop="price_zh" label="金币数量"></el-table-column>
      </el-table>
      <div class="page">
        <el-button type="primary" @click="turnPage('back')">上一页</el-button>
        <el-button type="primary" @click="turnPage('go')">下一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../api/request";
// import { format } from "date-fns";
export default {
  name: "Transcations",
  data() {
    return {
      tableData: [],
      loading: false,
      hasNext: true,
      userId: "",
      // time: [new Date(), new Date()],
      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: "最近一周",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "最近一个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "最近三个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     }
      //   ]
      // },
      pageSize: 20,
      pageIndex: 0,
      type: {
        invite: "推荐奖励",
        platform: "平台奖励",
        subsidy: "平台补贴",
        withdrawal: "金币兑换",
        expire: "金币过期",
        consume: "金币消费"
      }
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      let filters = {};
      if (this.userId) {
        filters.user_id = parseInt(this.userId, 10);
      }
      console.log(filters)
      const resp = await request.wallet.post("log_list", {
        range: [
          this.pageIndex * this.pageSize,
          this.pageIndex * this.pageSize + this.pageSize
        ],
        filter: filters
      });
      resp.data.list.length < this.pageSize
        ? (this.hasNext = false)
        : (this.hasNext = true);
      this.tableData = resp.data.list.map(item => {
        return {
          ...item,
          price_zh: (item.amount / 100).toFixed(2),
          type: item.op === "i" ? "入账" : "出账",
          source_type: this.type[item.type]
        };
      });
    },
    turnPage(type) {
      if (type === "go" && this.hasNext) {
        this.pageIndex++;
        this.getListData();
      } else if (type === "back" && this.pageIndex !== 0) {
        this.pageIndex--;
        this.getListData();
      }
    }
  }
};
</script>

<style scoped>
h4 {
  text-align: left;
}
.page {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.container-head {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.container-head label {
  margin-right: 10px;
}
.input {
  width: 200px;
  margin-right: 10px;
}
.btn {
  margin-left: 10px;
}
</style>
